import { createRoot } from "react-dom/client";
import CarOrdering from "./CarSystem/CarOrdering";

document.addEventListener('DOMContentLoaded', () => {
  const element = document.querySelector('[data-react-class="NellemannCarOrderingLight"]')

  if (!element) {
    return
  }

  const props = element.dataset.reactProps ? JSON.parse(element.dataset.reactProps) : {}
  const root = createRoot(element)

  root.render(<CarOrdering {...props} />)
})
